/**
 * The external dependencies.
 */
import React from 'react';
import styled from 'styled-components';
/**
 * The internal dependencies.
 */
import InputNumpad from '../../../../components/general/input-numpad';
import Button from '../../../../components/task/shop/form/button';
import BackButton from '../../../../components/general/back-button';

const QuantityWrapper = styled.div`
`;

const ToManyWrapper = styled.div`
    margin: 2px;
`;

const ValueWrapper = styled.div`
	min-width: 138px;
	background: #fff;
	border-radius: 5px;
`;


const Value = styled.a`
	display: block;
	text-decoration: none;
	font-size: 16px;
	color: ${({value, input}) => parseInt(value) === 0 || input ? '#4a4a50' : '#43aaf1'};
	padding: ${({input}) => input ? '0 0 15px' : '11px 14px 8px'};
`;

const InputWrapper = styled.div`
	position: absolute;
	z-index: 10;
	display:flex;
	justify-content: space-between;
	background: #fff;
	min-width: 456px;
	padding: 13px;
	border: 1px solid #95989a;
	border-radius: 5px;
`;

const ControlsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
`;

class Quantity extends React.Component {
    constructor() {
        super();

        this.state = {
            expanded: null,
            current: null,
            tomany: false,
        }
    }

    toggle() {
        const {expanded} = this.state;

        this.setState({expanded: !expanded})
    }

    handleSelect = (number) => {
        const {current} = this.state;

        this.setState({
            current: `${parseInt(current) ? current : ''}${number}`
        });
    };

    handleComplete = () => {
        this.toggle();
        const {max} = this.props;
        const {current} = this.state;
        if (current > max) {
            this.state.current = max;
            this.setState({tomany: true});
        }
        this.props.handleChange(this.state.current);
    };

    handleClear = () => {
        const {current} = this.state;

        const removeLastNumeral = (current) => current.toString().replace(/\d$/, '');

        const newValue = parseInt(current) ? removeLastNumeral(current) : null;

        this.setState({
            current: newValue > 0 ? newValue : null
        });
    };

    render() {
        const {expanded, current, tomany} = this.state;
        const {max} = this.props;

        const value = current ? current : '000';

        if (expanded) {
            return (
                <InputWrapper>
                    <ControlsWrapper>
                        <div>
                            <Value input>{value}</Value>

                            <Button handleClick={this.handleComplete} width="153px"/>
                        </div>

                        <BackButton
                            handleClick={this.handleClear}
                            width="153px"
                            border="1px"
                            chevronPosition={`
								top: 12px;
								left: 11px;
							`}
                            text="Löschen"
                        />
                    </ControlsWrapper>

                    <InputNumpad handleClick={this.handleSelect}/>
                </InputWrapper>
            );
        }


        return (
            <QuantityWrapper>
                <ValueWrapper>
                    <Value value={value} href="#" onClick={(e) => {
                        e.preventDefault();
                        this.toggle();
                    }}>{value}</Value>
                </ValueWrapper>
                {tomany && <ToManyWrapper>
                    {max > 1
                        ? <small>Maximal {max} Bauteile wählbar.</small>
                        : <small>Maximal {max} Bauteil wählbar.</small>
                    }
                </ToManyWrapper>}
            </QuantityWrapper>
        );
    }
}

export default Quantity;



// WEBPACK FOOTER //
// ./src/components/task/working/report/quantity.js